import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../ui/Button';

export type PremiumCapability =
  | 'bilt_premium'
  | 'premium_maintenance'
  | 'premium_ai'
  | 'premium_reports'
  | 'premium_documents'
  | 'premium_presentation';

type PremiumFeatureGateProps = {
  locked: boolean;
  capability?: PremiumCapability;
  title: string;
  description: string;
  children?: React.ReactNode;
  className?: string;
};

/**
 * Contextual Premium upsell. Only render when a Premium action was attempted.
 * Do not use as a Garage interstitial.
 */
export const PremiumFeatureGate: React.FC<PremiumFeatureGateProps> = ({
  locked,
  title,
  description,
  children,
  className = '',
}) => {
  if (!locked) {
    return <>{children}</>;
  }

  return (
    <div
      className={`rounded-xl border border-orange-500/25 bg-orange-500/[0.06] p-5 ${className}`.trim()}
      role="region"
      aria-label="Bilt:Spec Premium"
    >
      <p className="text-sm font-semibold text-orange-100">{title}</p>
      <p className="mt-2 text-sm text-zinc-400 leading-relaxed">{description}</p>
      <div className="mt-4 flex flex-wrap gap-3">
        <Link to="/settings/billing">
          <Button type="button" size="sm">
            Explore Bilt:Spec Premium
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default PremiumFeatureGate;
